import React, { useState } from "react";
import LendyIcon from "../../components/lendy/LendyIcon";
import MemoryView from "./MemoryView";
import InstructionsView from "./InstructionsView";

/** A row that opens its section under itself, and closes it again. */
const IdentitySection = ({ id, icon, title, summary, isOpen, onToggle, children }) => (
  <li className="lendy-profile-entry">
    <button
      type="button"
      className="lendy-profile-item lendy-profile-item--section"
      aria-expanded={isOpen}
      aria-controls={`lendy-identity-${id}`}
      onClick={onToggle}
    >
      <span className="lendy-profile-tile">
        <LendyIcon name={icon} />
      </span>
      <span className="lendy-profile-item-text">
        <b>{title}</b>
        <small>{summary}</small>
      </span>
      <LendyIcon name="right" size={14} />
    </button>
    {isOpen && (
      <div id={`lendy-identity-${id}`} className="lendy-profile-section">
        {children}
      </div>
    )}
  </li>
);

/** Instructions (who it is) and Memory (yours alone), each opened in place under its row. Apps has its own tab. */
const IdentityTab = ({ identity, agentId, assistantName }) => {
  const [openSections, setOpenSections] = useState([]);

  const toggle = (id) =>
    setOpenSections((open) => (open.includes(id) ? open.filter((openId) => openId !== id) : [...open, id]));

  return (
    <ul className="lendy-profile-list">
      <IdentitySection
        id="instructions"
        icon="sparkle"
        title="Instructions"
        summary={`Who ${assistantName} is`}
        isOpen={openSections.includes("instructions")}
        onToggle={() => toggle("instructions")}
      >
        <InstructionsView identity={identity} agentId={agentId} assistantName={assistantName} />
      </IdentitySection>
      <IdentitySection
        id="memory"
        icon="book"
        title="Memory"
        summary={`What ${assistantName} remembers`}
        isOpen={openSections.includes("memory")}
        onToggle={() => toggle("memory")}
      >
        <MemoryView identity={identity} assistantName={assistantName} />
      </IdentitySection>
    </ul>
  );
};

export default IdentityTab;
